module.exports = __webpack_public_path__ + "img/banner-6.8d18ddd9.jpg";